/* STILLPUNKT global.js — no dependencies, ~3 KB gzipped */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const money = (cents, format) =>
    (format || '{{amount}} €').replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toFixed(2).replace('.', ','));

  function cartAddItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
  }
  function formToItems(form) {
    const id = form.querySelector('input[name="id"]').value;
    const qtyInput = form.querySelector('input[name="quantity"]');
    const items = [{ id: Number(id), quantity: Number(qtyInput ? qtyInput.value : 1) }];
    const gift = form.querySelector('input[name="gift_variant"]:checked');
    if (gift) items.push({ id: Number(gift.value), quantity: 1 });
    return items;
  }

  /* ---------- mobile nav ---------- */
  const burger = $('.header__burger');
  if (burger) burger.addEventListener('click', () => {
    const nav = $('.header__nav');
    const open = nav.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open);
  });

  /* ---------- cart drawer ---------- */
  const drawer = $('#CartDrawer');
  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; } }
  $$('.js-cart-open').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openDrawer(); }));
  $$('.js-cart-close').forEach(b => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  async function refreshCart() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    $$('.cart-count').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    const list = $('#CartDrawerItems');
    if (!list) return cart;
    if (cart.item_count === 0) {
      list.innerHTML = '<p class="cart-drawer__empty">' + (list.dataset.empty || 'Dein Warenkorb ist leer.') + '</p>';
    } else {
      list.innerHTML = cart.items.map(i => `
        <div class="cart-line">
          <img src="${i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') : ''}" alt="" width="72" height="72" loading="lazy">
          <div>
            <div class="cart-line__title">${i.product_title}</div>
            ${i.variant_title && i.variant_title !== 'Default Title' ? `<div class="cart-line__variant">${i.variant_title}</div>` : ''}
            <div class="cart-line__variant">× ${i.quantity}</div>
            <button class="cart-line__remove" data-key="${i.key}" type="button">${list.dataset.remove || 'Entfernen'}</button>
          </div>
          <div class="cart-line__price">${money(i.final_line_price, list.dataset.moneyFormat)}</div>
        </div>`).join('');
      $$('.cart-line__remove', list).forEach(btn => btn.addEventListener('click', async () => {
        await fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
        });
        refreshCart();
      }));
    }
    const sub = $('#CartDrawerSubtotal');
    if (sub) sub.textContent = money(cart.total_price, list.dataset.moneyFormat);

    return cart;
  }
  if (drawer) refreshCart();

  /* ---------- AJAX add to cart ---------- */
  $$('form[data-ajax-cart]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      btn.disabled = true;
      try {
        const res = await cartAddItems(formToItems(form));
        if (!res.ok) throw new Error();
        await refreshCart();
        openDrawer();
      } catch (_) {
        window.location.href = '/cart';
      } finally { btn.disabled = false; }
    });
  });

  /* Bundle quick-add buttons: data-variant-id + data-qty */
  $$('.js-bundle-add').forEach(btn => {
    btn.addEventListener('click', async () => {
      const id = btn.dataset.variantId; if (!id) return;
      btn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(id), quantity: Number(btn.dataset.qty || 1) })
        });
        await refreshCart();
        openDrawer();
      } finally { btn.disabled = false; }
    });
  });

  /* ---------- bundle tier radios → quantity ---------- */
  $$('input[name="bundle_qty"]').forEach(r => r.addEventListener('change', () => {
    const qtyInput = $('form[data-product-form] input[name="quantity"]');
    if (qtyInput) qtyInput.value = r.value;
  }));

  /* ---------- Buy Now: add then straight to checkout ---------- */
  const buyNow = $('#BuyNowBtn');
  if (buyNow) buyNow.addEventListener('click', async () => {
    const form = buyNow.closest('form');
    buyNow.disabled = true;
    try {
      const res = await cartAddItems(formToItems(form));
      if (!res.ok) throw new Error();
      window.location.href = '/checkout';
    } catch (_) {
      buyNow.disabled = false;
    }
  });


  /* ---------- product info tabs ---------- */
  $$('[data-ptabs]').forEach(tabs => {
    const btns = $$('[role="tab"]', tabs);
    const panels = $$('.ptabs__panel', tabs);
    btns.forEach((b, i) => b.addEventListener('click', () => {
      btns.forEach(x => x.setAttribute('aria-selected', 'false'));
      panels.forEach(p => p.classList.remove('is-active'));
      b.setAttribute('aria-selected', 'true');
      panels[i].classList.add('is-active');
    }));
  });

  /* ---------- quantity steppers ---------- */
  $$('.qty').forEach(q => {
    const input = $('input', q);
    $$('button', q).forEach(b => b.addEventListener('click', () => {
      const v = Math.max(1, Number(input.value) + (b.dataset.dir === 'up' ? 1 : -1));
      input.value = v;
    }));
  });

  /* ---------- product gallery ---------- */
  const mainImg = $('#ProductMainImage');
  $$('.product__thumbs img').forEach(t => t.addEventListener('click', () => {
    if (!mainImg) return;
    mainImg.src = t.dataset.full;
    $$('.product__thumbs img').forEach(i => i.classList.remove('is-active'));
    t.classList.add('is-active');
  }));

  /* ---------- variant price sync ---------- */
  const productForm = $('form[data-product-form]');
  if (productForm) {
    const dataEl = $('#ProductJSON');
    const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    const idInput = $('input[name="id"]', productForm);
    productForm.addEventListener('change', e => {
      if (!e.target.matches('input[name="Farbe"],input[name="Color"]')) return;
      const chosen = e.target.value;
            const v = variants.find(v => v.option1 === chosen);
      if (v) {
        idInput.value = v.id;
        const priceEl = $('#ProductPrice');
        if (priceEl) priceEl.textContent = money(v.price, priceEl.dataset.moneyFormat);
        const stickyPrice = $('.sticky-atc__price');
        if (stickyPrice) stickyPrice.textContent = money(v.price, priceEl ? priceEl.dataset.moneyFormat : undefined);
        if (v.image && mainImg) {
          mainImg.src = v.image;
          $$('.product__thumbs img').forEach(i => {
            i.classList.toggle('is-active', i.dataset.full === v.image);
          });
        }
      }
    });
  }

  /* ---------- sticky mobile ATC ---------- */
  const sticky = $('.sticky-atc');
  const atcBtn = $('#AddToCartBtn');
  if (sticky && atcBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) =>
      sticky.classList.toggle('is-visible', !en.isIntersecting)
    ).observe(atcBtn);
    $('.sticky-atc .btn').addEventListener('click', () => {
      atcBtn.closest('form').requestSubmit();
    });
  }
})();
